import { useEffect, useState } from "react";
import { isDev } from "../../../base/index.js";
import { useWarnToMemoize } from "../../../hooks/index.js";
import { createForm } from "../../core/createForm/createForm.js";
import { registerFormToDevtools } from "../devtools/formDevtools.js";
import { useFormVerboseMode } from "./useFormVerboseMode.js";
function useCreateForm(maybeLazyConfig, verbose = false) {
  const [config] = useState(() => {
    let tmpConfig = typeof maybeLazyConfig === "function" ? maybeLazyConfig() : maybeLazyConfig;
    if (!tmpConfig) {
      const defaultConfig = { id: "default-form", initialValues: {} };
      if (isDev()) {
        console.warn("Form configuration is missing, a default one has been created", defaultConfig);
      }
      tmpConfig = defaultConfig;
    }
    return tmpConfig;
  });
  const [formState] = useState(() => createForm(config));
  useWarnToMemoize(maybeLazyConfig, {
    name: "[useCreateForm].maybeLazyConfig",
    limit: 1,
    message: "Form configuration cannot dynamically change. Please notice that the Form will not be updated."
  });
  useFormVerboseMode(config.id, verbose ? "verbose" : "silent", formState.api);
  useEffect(() => {
    const unregister = registerFormToDevtools(formState);
    return () => {
      unregister();
    };
  }, [formState]);
  return formState;
}
export {
  useCreateForm
};
//# sourceMappingURL=useCreateForm.js.map
